import { render, staticRenderFns } from "./ChinaIpGoods.vue?vue&type=template&id=148d6a01&scoped=true&"
import script from "./ChinaIpGoods.vue?vue&type=script&lang=js&"
export * from "./ChinaIpGoods.vue?vue&type=script&lang=js&"
import style0 from "./ChinaIpGoods.vue?vue&type=style&index=0&id=148d6a01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d6a01",
  null
  
)

export default component.exports